import { api } from './Fetcher';

export const postSignIn = (data: any): Promise<any> => {
  return api.post('/signin/', data);
};

export const postPasswordReset = (data: any): Promise<any> => {
  return api.post('/signin/send-password/', data);
};
